import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
import { featuredReview } from '../data/reviews';
export function FeaturedReview() {
  return <Section className="max-w-3xl !py-8 md:!py-12" data-id="element-95" data-mp="206qd94alu5x1">
      <figure className="text-center" data-id="element-96" data-mp="2dymta9z00pd2">
        <div className="flex justify-center gap-0.5 text-amber-400" aria-label="Valutazione 5 su 5" data-id="element-97" data-mp="2e1sjjsjd5xad">
          {Array.from({
          length: 5
        }, (_, index) => <StarIcon key={index} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-98" data-mp="1lc23vf232nc5" />)}
        </div>
        <blockquote className="mt-5 text-lg leading-relaxed text-stone-900 md:text-2xl md:leading-relaxed" data-id="element-99" data-mp="1hb0a3dqxr3hk">
          «{featuredReview.text}»
        </blockquote>
        <figcaption className="mt-6 flex items-center justify-center gap-3" data-id="element-100" data-mp="1q9u5j0sj5ntj">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-rose-100 text-sm font-semibold text-rose-800" aria-hidden="true" data-id="element-101" data-mp="36on0ifgz2ej3">
            {featuredReview.initials}
          </span>
          <span className="text-left" data-id="element-102" data-mp="2iimdzp098jrs">
            <span className="block text-sm font-semibold text-stone-900" data-id="element-103" data-mp="2ihkvizgwsv01">{featuredReview.name}</span>
            <span className="block text-xs text-stone-500" data-id="element-104" data-mp="2nfw291bwqpe1">
              {featuredReview.location} · {featuredReview.role}
            </span>
          </span>
        </figcaption>
      </figure>
    </Section>;
}